import { Button } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
// import CreateEditBusinessUnitModal from "./createEditBusinessUnit";
import {
  actionsColumn,
  hideColumn,
  textColumn
} from "../../components/tableComponent/columns";
import TableComponent from "../../components/tableComponent";
// import "./styles.css";
import {
  CreateUpdateAlert,
  callApiAsync,
  GetAlertList,
} from "../../services/apiService";
import AlertComponent from "../../components/alertModal";
import ToastNotification from "../../components/toastNotification";
import ButtonComponent from "../../components/button";
import icons from "../../constants/icons";
import UploadDocumentModal from "./UploadDocumentModal";

const SystemAlert = () => {
  const [AlertList, setAlertList] = useState([]);
  const [openCreateEdit, setOpenCreateEdit] = useState(false);

  const [selectedRow, setSelectedRow] = useState({});

  const [alertOpen, setAlertOpen] = useState(false);

  const [toastMessage, setToastMessage] = useState("");
  const [toastOpen, setToastOpen] = useState(false);
  const [toastSeverity, setToastSeverity] = useState("warning");

  const getUserApiTable = () => {
    callApiAsync(GetAlertList, (data) => {
      setAlertList(data);
    });
  };

  useEffect(() => {
    getUserApiTable();
  }, []);

 const createAlert = (formData) => {
    console.log(formData)
    callApiAsync(
      () => CreateUpdateAlert(formData),
      (data) => {
      getUserApiTable();
        
      }
    );
  };

  const handleCreateEdit = (row) => {
    console.log(row);
    if (!row) {
      setSelectedRow(null);
      setOpenCreateEdit(true);
      return;
    }
    setSelectedRow(row);
    setOpenCreateEdit(true);
  };

  const handleClose = () => {
    setOpenCreateEdit(false);
    setSelectedRow(null);
  };

  const handleCopy = (row) => {
    const apiKey = row.apiKey;
    navigator.clipboard.writeText(apiKey)
      .then(() => {
        console.log("Copiado al portapapeles:", apiKey);
      })
      .catch(err => {
        console.error("Error al copiar:", err);
      });
  };

  const actionBtn = ({ row }) => {
    const rowDate = new Date(row.original.Date);
    const now = new Date();

    if (rowDate >= now) {
      return null;
    }
    return (
      <div className="HContainer">
        <ButtonComponent
          onClick={() => handleCreateEdit(row.original)}
          variant="contained"
          backgroundColor="#fff0"
        >
          <img className="btn-icon" src={icons.blue_edit} alt="icon" />
        </ButtonComponent>
      </div>
    );
  }
    
  const columns = useMemo(
    () => [
      hideColumn("id", "id"),
      textColumn("alertDate", "Fecha"),
      textColumn("title", "Titulo"),
      textColumn("message", "Descripcion"),
      actionsColumn(actionBtn)
    ],
    []
  );

  return (
    <div>
      <h1>Alertas</h1>
      <div>
        <TableComponent
          columns={columns}
          data={AlertList}
          enableGlobalFilter={true}
          initialState={{
            sorting: [
              {
                id: "date",
                desc: true
              }
            ]
          }}
          headerButtons={() =>
            <>
              <ButtonComponent
                onClick={() => handleCreateEdit()}
                type="submit"
                variant="contained"
                backgroundColor="#F6C079"
                textColor="#000000"
                margin="15px 0"
              >
                <div className="HContainer a-center">
                  <img
                    className="btn-icon icon-margin-r-15"
                    src={icons.plus}
                    alt="icon"
                  />
                  <p>Crear Alerta</p>
                </div>
              </ButtonComponent>
            </>
          }
        />
      </div>
      <UploadDocumentModal 
        open={openCreateEdit} 
        onClose={handleClose} 
        rowData={selectedRow}
        onSubmitFunction={createAlert}/>
      <ToastNotification
        open={toastOpen}
        handleClose={() => setToastOpen(false)}
        message={toastMessage}
        severity={toastSeverity}
      />
    </div>
  );
};

export default SystemAlert;
